import { render, staticRenderFns } from "./LaboratioCertificado.vue?vue&type=template&id=ff2b3af8"
import script from "./LaboratioCertificado.vue?vue&type=script&lang=js"
export * from "./LaboratioCertificado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports